import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { promptsAPI } from '../services/api';

const PromptsList = () => {
  const [prompts, setPrompts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const loadPrompts = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await promptsAPI.list();
      const data = res.data?.data || res.data || [];
      setPrompts(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(e?.response?.data?.error || e.message || 'Erro ao carregar prompts');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadPrompts(); }, [loadPrompts]);

  const openDetail = (p) => navigate(`/prompts/${p.id}`);

  const deletePrompt = async (p) => {
    const name = p?.name || `ID ${p?.id}`;
    const confirmed = window.confirm(`Deseja excluir/desativar o prompt "${name}"?`);
    if (!confirmed) return;
    try {
      const res = await promptsAPI.remove(p.id);
      if (res.status >= 200 && res.status < 300) {
        alert('Prompt excluído/desativado com sucesso.');
        await loadPrompts();
      } else {
        alert(res?.data?.error || 'Falha ao excluir/desativar prompt');
      }
    } catch (e) {
      alert(e?.response?.data?.error || e.message || 'Erro ao excluir/desativar prompt');
    }
  };

  return (
    <div className="prompts-page">
      <div className="page-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2>💡 Prompts (Templates de IA)</h2>
        <button className="page-btn" onClick={loadPrompts}>Atualizar</button>
      </div>

      {loading && (
        <div className="loading" style={{ marginTop: '1rem' }}>Carregando prompts...</div>
      )}
      {error && (
        <div className="error" style={{ color: '#dc3545', marginTop: '1rem' }}>{error}</div>
      )}

      {!loading && prompts.length === 0 && !error && (
        <div className="empty-state" style={{ marginTop: '1rem', color: '#666' }}>Nenhum prompt cadastrado.</div>
      )}

      {!loading && prompts.length > 0 && (
        <div className="card" style={{ marginTop: '1rem' }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #eee' }}>Nome</th>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #eee' }}>Categoria</th>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #eee' }}>Tom</th>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #eee' }}>Tamanho</th>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #eee' }}>Ativo</th>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #eee' }}>Uso</th>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #eee' }}>Atualizado</th>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #eee' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {prompts.map((p) => (
                  <tr key={p.id}>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f4f4f4' }}>
                      <button className="link-btn" onClick={() => openDetail(p)} style={{ color: '#0d6efd', background: 'transparent', border: 'none', cursor: 'pointer' }}>
                        {p.name}
                      </button>
                    </td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f4f4f4' }}>{p.category || '-'}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f4f4f4' }}>{p.tone || '-'}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f4f4f4' }}>{p.length || '-'}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f4f4f4' }}>{p.is_active ? 'Sim' : 'Não'}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f4f4f4' }}>{p.usage_count ?? 0}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f4f4f4' }}>{p.updated_at ? new Date(p.updated_at).toLocaleString('pt-BR') : '-'}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f4f4f4' }}>
                      <button className="page-btn" onClick={() => openDetail(p)}>Editar</button>
                      <button 
                        className="page-btn" 
                        onClick={() => deletePrompt(p)} 
                        style={{ marginLeft: '0.5rem', background: '#dc3545', borderColor: '#dc3545' }}
                        title="Excluir/desativar"
                      >
                        Excluir
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default PromptsList;